const state = {
  coreTableTab: '1',
  coreUnitTableTab: '1',
  coreTeamPage: '', // 核心单位页码暂存
  coreTeamBaseindex: 0, // 核心单位基地切换
  proteapage: '', // 过程化教学页码暂存
  bigEventPage: '' // 大型赛事页码暂存
}
const mutations = {
  changeCoreTableTab: (state, v) => {
    state.coreTableTab = v;
  },
  changeCoreUnitTableTab: (state, v) => {
    state.coreUnitTableTab = v;
  },
  changeCoreTeampage: (state, v) => {
    state.coreTeamPage = v;
  },
  changeCTBaseIndex: (state, v) => {
    state.coreTeamBaseindex = v;
  },
  changeProteapage: (state, v) => {
    state.proteapage = v;
  },
  changebigEvepage: (state, v) => {
    state.bigEventPage = v;
  }
}
const actions = {
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/website.js